import { Component, Input } from '@angular/core';

import { MenuComponent } from '../menu.component';

@Component({
  selector: 'customer-menu-router-item',
  templateUrl: './menu-router-item.component.html',
  styles: [''],
})
export class MenuRouterItemComponent<T> {
  @Input() readonly disabled: boolean = false;

  _tooltipText?: string;
  @Input() set tooltipText(value: string | undefined) {
    this._tooltipText = value?.toUpperCase();
  }

  constructor(readonly menu: MenuComponent<T>) {}
}
